import React from "react";
//import styled from "styled-components";

export default function AboutMeSection() {
    return <p>Under construction</p>;
}
